import React from 'react'
import classNames from 'classnames'

import { TextTableRow, TextTableRowProps } from './TextTable.Row'
import { TextTableCell, TextTableCellProps } from './TextTable.Cell'

interface ContentTableProps {
  className?: string
  children: React.ReactNode
}

type TextTableType = React.FC<ContentTableProps> & {
  Row: React.FC<TextTableRowProps>
  Cell: React.FC<TextTableCellProps>
}

export const TextTable: TextTableType = (props) => {
  const { className, children } = props
  return (
    <div className={classNames('table table-fixed phone:w-full', className)}>
      {children}
    </div>
  )
}

TextTable.Row = TextTableRow
TextTable.Cell = TextTableCell
